// extracted by mini-css-extract-plugin
module.exports = {"notificationDropdown":"DesktopNotificationDropdown_notificationDropdown__1QkHR"};